import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { ThemeProvider } from '@material-ui/core/styles';
import MyTheme from '../../MyTheme';
import logoDrakkar from '../../assets/logo_drakkar.png';
import logoIPA from '../../assets/logo IPA.png';
import logoIF from '../../assets/logo IF.png';

export function ServiceDisabledScreen() {
    return (
        <ThemeProvider theme={MyTheme}>
            <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    padding: 16,
                }}
            >
                <Paper
                    elevation={4}
                    style={{
                        maxWidth: 560,
                        width: '100%',
                        padding: '48px 32px',
                        textAlign: 'center',
                        background: 'rgba(255, 255, 255, 0.85)',
                        backdropFilter: 'blur(20px)',
                        WebkitBackdropFilter: 'blur(20px)',
                        borderRadius: 20,
                        border: '1px solid rgba(209, 213, 219, 0)',
                        boxShadow: '4px 2px 50px rgba(0, 0, 0, 0.2)',
                    }}
                >
                    <Box display="flex" justifyContent="center" alignItems="center" style={{ gap: 24, marginBottom: 32 }}>
                        <img
                            src={logoIPA}
                            alt="IPA"
                            style={{ maxWidth: '6rem', width: '100%' }}
                        />
                        <img
                            src={logoIF}
                            alt="IF"
                            style={{ maxWidth: '6rem', width: '100%' }}
                        />
                    </Box>
                    <Typography variant="body1" color="textSecondary">
                        Os serviços IPA e IF estão desativados por tempo indeterminado.
                    </Typography>
                </Paper>
                <Box
                    display="flex"
                    justifyContent="flex-end"
                    alignItems="center"
                    style={{ gap: 8, position: 'absolute', bottom: 24, right: 24 }}
                >
                    <img
                        src={logoDrakkar}
                        alt="Drakkar"
                        style={{ maxWidth: '2rem', width: '100%' }}
                    />
                    <Typography variant="caption" style={{ fontWeight: 600, color: '#888', whiteSpace: 'nowrap' }}>
                        Drakkar Agricultura de Precisão
                    </Typography>
                </Box>
            </Box>
        </ThemeProvider>
    );
}
